import { Popover, Transition } from "@headlessui/react";
import { FC } from "react";

import FilterButton from "./filter-button";

import { classNames } from "@utils/class-names";

interface Props {
  text: string;
  className?: string;
}

const FilterPopover: FC<Props> = ({ text, className, children }) => (
  <Popover>
    {({ open }) => (
      <div className={classNames("relative", open ? "z-40" : "")}>
        <Popover.Button>
          <FilterButton {...{ text, open }} />
        </Popover.Button>
        <Transition
          show={open}
          // TODO: If unmount is true, the slider thumbs are in correct place but the enter transition is broken, if it is false the transition works but the slider thumbs are broken
          // unmount={false}
          enter="transition duration-200 origin-top ease-out"
          enterFrom="scale-0"
          enterTo="scale-100"
          leave="transition duration-100 origin-top ease-in"
          leaveFrom="scale-100"
          leaveTo="scale-0"
        >
          <Popover.Panel
            static
            className={classNames(
              "flex flex-col divide-y-2 rounded divide-gray-500 border-gray-200 border-2 bg-white absolute w-[200px]",
              className || ""
            )}
          >
            {children}
          </Popover.Panel>
        </Transition>
      </div>
    )}
  </Popover>
);

export default FilterPopover;
